<template>
    <div class="container-fluid">
        <div>
            <div class="card">
                <div class="card-header">
                    <div class="row">
                        <div class="col col-xs-2">
                            <h4 class="panel-title">
                                <span class="title">Gereciamento Obras</span>
                                <br/>
                                <span class="navigation">Obras > Cadastro</span>
                            </h4>
                        </div>
                    </div>
                </div>
            <div class="card-body">
							<form name="form" @submit.prevent="onSubmit">
								<div>
									<template v-if="validation.hasError('obras.numeroCei')">
											<InlineMessage>{{ validation.firstError('obras.numeroCei') }}</InlineMessage>
									</template>

									<template v-if="validation.hasError('obras.numeroArt')">
											<InlineMessage>{{ validation.firstError('obras.numeroArt') }}</InlineMessage>
									</template>

									<template v-if="validation.hasError('obras.numeroAlvara')">
											<InlineMessage>{{ validation.firstError('obras.numeroAlvara') }}</InlineMessage>
									</template>

									<template v-if="validation.hasError('obras.dataInicio')">
											<InlineMessage>{{ validation.firstError('obras.dataInicio') }}</InlineMessage>
									</template>

									<template v-if="validation.hasError('obras.dataTermino')">
											<InlineMessage>{{ validation.firstError('obras.dataTermino') }}</InlineMessage>
									</template>

									<template v-if="validation.hasError('obras.saldoDisponivel')">
											<InlineMessage>{{ validation.firstError('obras.saldoDisponivel') }}</InlineMessage>
									</template>

									<template v-if="validation.hasError('obras.saldoDeduzido')">
											<InlineMessage>{{ validation.firstError('obras.saldoDeduzido') }}</InlineMessage>
									</template>

									<template v-if="validation.hasError('obras.enderecoObra')">
											<InlineMessage>{{ validation.firstError('obras.enderecoObra') }}</InlineMessage>
									</template>

									<template v-if="validation.hasError('obras.nome')">
											<InlineMessage>{{ validation.firstError('obras.nome') }}</InlineMessage>
									</template>

									<template v-if="validation.hasError('obras.descricao')">
											<InlineMessage>{{ validation.firstError('obras.descricao') }}</InlineMessage>
									</template>

									<template v-if="validation.hasError('selectedTipoObra')">
											<InlineMessage>{{ validation.firstError('selectedTipoObra') }}</InlineMessage>
									</template>

									<template v-if="validation.hasError('selectedTipoDesconto')">
											<InlineMessage>{{ validation.firstError('selectedTipoDesconto') }}</InlineMessage>
									</template>
								</div>
									<div class="row d-flex align-items-end">
										<div class="col-md-2 mb-2">
												<label>Número CEI: *</label>
												<span class="p-fluid">
														<InputText
														type="text"
														v-model="obras.numeroCei"
														:class="{'p-error': validation.hasError('obras.numeroCei')}"
														></InputText>
												</span>
										</div>
								
										<div class="col-md-2 mb-2">
												<label>Número ART: *</label>
												<span class="p-fluid">
														<InputText
														type="text"
														v-model="obras.numeroArt"
														:class="{'p-error': validation.hasError('obras.numeroArt')}"
														></InputText>
												</span>
										</div>

										<div class="col-md-2 mb-2">
												<label>Número Alvará: *</label>
												<span class="p-fluid">
														<InputText
														type="text"
														v-model="obras.numeroAlvara"
														:class="{'p-error': validation.hasError('obras.numeroAlvara')}"
														></InputText>
												</span>
										</div>

										<div class="col-md-3 mb-2">
											<label for="nome">Nome Obra: *</label>
											<span class="p-fluid">
												<InputText
													type="text"
													id="nome"
													v-model="obras.nome"
													:class="{'p-error': validation.hasError('obras.nome')}"
												/>
											</span>
										</div>
									</div>
									<div class="row d-flex align-items-end">
										<div class="col-md-2 mb-2">
											<label for="dataInicio">Data Início: *</label>
											<span class="p-fluid">
													<Calendar
													id="dataInicio"
													name="dataInicio"
													v-model="obras.dataInicio"
													:class="{'p-error': validation.hasError('obras.dataInicio')}"
													:showIcon="true"
													dateFormat="dd/mm/yy"
													/>
											</span>
										</div>

										<div class="col-md-2 mb-2">
											<label for="dataTermino">Data Término: *</label>
											<span class="p-fluid">
													<Calendar
													id="dataTermino"
													name="dataTermino"
													v-model="obras.dataTermino"
													:class="{'p-error': validation.hasError('obras.dataTermino')}"
													:showIcon="true"
													dateFormat="dd/mm/yy"
													/>
											</span>
										</div>

										<div class="col-md-2 mb-2">
											<label for="saldoDisp">Saldo Disponível:</label>
											<span class="p-fluid">
													<money
													id="saldoDisp"
													name="saldoDisp"
													v-model="obras.saldoDisponivel"
													:class="{'p-error': validation.hasError('obras.saldoDisponivel')}"
													v-bind="money"
													class="p-inputtext input-right"
													disabled    
													></money>
											</span>
										</div>

										<div class="col-md-2 mb-2">
											<label for="saldoDeduz">Saldo Deduzido:</label>
											<span class="p-fluid">
													<money
													id="saldoDeduz"
													name="saldoDeduz"
													v-model="obras.saldoDeduzido"
													:class="{'p-error': validation.hasError('obras.saldoDeduzido')}"
													v-bind="money"
													class="p-inputtext input-right"
													disabled
													></money>
											</span>
										</div>
									</div>
								<div class="row">
									<div class="col-md-10 mb-2">
											<label for="enderecoObra">Endereço Obra: *</label>
											<span class="p-fluid">
													<textarea
														id="enderecoObra"
														name="enderecoObra"
														v-model="obras.enderecoObra"
														:class="{'p-error': validation.hasError('obras.enderecoObra')}"
														rows="5"
													/>
											</span>
									</div>
								</div>
								<div class="row">
									
									<div class="col-md-3 mb-2">
										<label for="tipoObra">Tipo Obra:</label>
										<span class="p-fluid">
											<AutoComplete
												id="tipoObra"
												v-model="selectedTipoObra"
												:dropdown="true"
												:suggestions="filteredTipoObra"
												@complete="searchTipoObra($event)"
												field="nome"
												placeholder="Pesquisar"
												:class="{
													'p-error': validation.hasError('selectedTipoObra'),
												}"
											>
												<template #item="slotProps">
													<div class="p-fluid" style="max-width: 50vw">
														{{ slotProps.item.nome }}
													</div>
												</template>
											</AutoComplete>
										</span>
									</div>

									<div class="col-md-3 mb-2">
										<label for="tipoDesconto">Tipo Desconto:</label>
										<span class="p-fluid">
											<AutoComplete
												id="tipoDesconto"
												v-model="selectedTipoDesconto"
												:dropdown="true"
												:suggestions="filteredTipoDesconto"
												@complete="searchTipoDesconto($event)"
												field="nome"
												placeholder="Pesquisar"
												:class="{
													'p-error': validation.hasError('selectedTipoDesconto'),
												}"
											>
												<template #item="slotProps">
													<div class="p-fluid" style="max-width: 50vw">
														{{ slotProps.item.nome }}
													</div>
												</template>
											</AutoComplete>
										</span>
									</div>

									<div class="col-md-4 mb-2">
										<label for="contrib">Contribuinte: *</label>
										<span class="p-fluid">
												<AutoComplete
												id="contrib"
												:dropdown="true"
												v-model="currentUser.contribuinte.nome"
												placeholder="Pesquisar"
												disabled
												>
												</AutoComplete>
										</span>
									</div>

									<div class="col-md-10 mb-2">
										<label for="descricao">Descrição: *</label>
										<span class="p-fluid">
												<textarea
													id="descricao"
													name="descricao"
													v-model="obras.descricao"
													:class="{'p-error': validation.hasError('obras.descricao')}"
													rows="5"
												/>
										</span>
									</div>
								</div>
									<hr />
								<template>
										<Button
												label="Gravar"
												title="Gravar"
												type="submit"
												class="p-button-primary mr-2 p-button-success"
												icon="pi pi-check"
												:disabled="loading"
										>
										</Button>
										<router-link to="/obrasConsulta">
												<Button
												label="Voltar"
												title="Voltar"
												type="button"
												class="p-button-primary mr-2"
												icon="pi pi-arrow-left"
												:disabled="loading"
												></Button>
										</router-link>
								</template>
							</form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import money from "../conf/config.money";
import LoginService from "../services/acesso/login.service";
import obrasService from '../services/obras/obras.service';
import Obras from '../models/obras/Obras';
import SimpleVueValidation from "simple-vue-validator";
const Validator = SimpleVueValidation.Validator;

export default {
	name: 'ObrasCadastro',
	data() {
		return{
			loading: false,
			money: money,
			filtro: "",
			filteredTipoObra: null,
			selectedTipoObra: null,
			filteredTipoDesconto: null,
			selectedTipoDesconto: null,
			obras: new Obras(),
		}
	},
	created(){
		this.currentUser = LoginService.currentUserValue;
		this.id = this.$route.params.idObras;

		if(this.id != null){
			setTimeout(async() => {
				await obrasService.getObras(this.id).then(
					response=>{
						this.obras = response.data;
						this.selectedTipoObra = this.obras.idTipoObra;
						this.selectedTipoDesconto = this.obras.idTipoAbatimento;
						this.obras.dataInicio = this.obras.dataInicio ? new Date(this.obras.dataInicio) : null;
						this.obras.dataTermino = this.obras.dataTermino ? new Date(this.obras.dataTermino) : null;
					},
					error=>{
						let errorMessage = "Houve um problema ao buscar Tipo Desconto!";
						if(error.response){
							errorMessage = error.response.data;
						}
						this.$toast.add({
							severity: "error",
							summary: errorMessage
						});
					}
				)
			},250);
		}
	},
	
	methods: {
		onSubmit(){
			this.loading = true;
			this.$validate().then((success) => {
				if (success) {
					this.salvar();
				}
			});
			this.loading = false;
		},

		salvar(){
			this.processando(true);
			if(!this.selectedTipoObra || !this.selectedTipoObra.id){
				this.$toast.add({
					severity: "error",
					summary: "Selecione um Tipo Obra!"
				});
				this.processando(false);
				return;
			}
			if(!this.selectedTipoDesconto || !this.selectedTipoDesconto.id){
				this.$toast.add({
					severity: "error",
					summary: "Selecione um Tipo Desconto!"
				});
				this.processando(false);
				return;
			}

			this.obras.idCliente = this.currentUser.usuario.idCliente;
			this.obras.idContribuinteCadastro = this.currentUser.contribuinte.idContribuinte;
			this.obras.idTipoObra = this.selectedTipoObra;
			this.obras.idTipoAbatimento = this.selectedTipoDesconto;

			obrasService.saveObras(this.obras).then(
				data => {
					console.log(data);
					this.$toast.add({
						severity: "success",
						summary: "Obra salva com sucesso!"
					});
					this.$router.push("obrasConsulta");
				},
				error => {
					let errorMessage = "Houve um erro ao salvar a Obra!";
					if(error.response){
						errorMessage = error.response.data;
					}
					this.$toast.add({
						severity: "error",
						summary: errorMessage
					});
				}
			);
			this.processando(false);
		},

		searchTipoObra(event){
			setTimeout(async () => {
				this.filteredTipoObra = await obrasService.findTipoObraByFiltro(
					this.currentUser.usuario.idCliente,
					event.query
				);
			}, 550);
		},

		searchTipoDesconto(event){
			setTimeout(async () => {
				this.filteredTipoDesconto = await obrasService.findTipoDescontoByFiltro(
					this.currentUser.usuario.idCliente,
					event.query
				);
			}, 550);
		},

		limparForm(){
			this.obras.saldoDisponivel = 0;
			this.obras.saldoDeduzido = 0;
			this.obras.numeroCei = '';
			this.obras.numeroArt = '';
			this.obras.numeroAlvara = '';
			this.obras.nome = '';
			this.obras.dataInicio = '';
			this.obras.dataTermino = '';
			this.obras.enderecoObra = '';
			this.selectedTipoObra = null;
			this.selectedTipoDesconto = null;
			this.obras.descricao = '';
		},

		processando(show) {
			if (show) {
				this.loading = true;
				this.$root.$emit("loading:show");
			} else {
				this.loading = false;
				this.$root.$emit("loading:hide");
			}
		}
	},

	validators: {
		"obras.numeroCei": function(value){
			return Validator.value(value)
			.required("Número CEI Obrigatório")
			.maxLength(200, "Deve ser menor ou igual a 200")
		},
		"obras.numeroArt": function(value){
			return Validator.value(value)
			.required("Número ART Obrigatório")
			.maxLength(200, "Deve ser menor ou igual a 200")
		},
		"obras.numeroAlvara": function(value){
			return Validator.value(value)
			.required("Número Alvará Obrigatório")
			.maxLength(200, "Deve ser menor ou igual a 200")
		},
		"obras.dataInicio": function(value){
			return Validator.value(value)
			.required("Data Início Obrigatório")
			.maxLength(200, "Deve ser menor ou igual a 200")
		},
		"obras.dataTermino": function(value){
			return Validator.value(value)
			.required("Data Término Obrigatório")
			.maxLength(200, "Deve ser menor ou igual a 200")
		},
		"obras.saldoDisponivel": function(value){
			return Validator.value(value)
			.required("Saldo Disponível Obrigatório")
			.maxLength(200, "Deve ser menor ou igual a 200")
		},
		"obras.saldoDeduzido": function(value){
			return Validator.value(value)
			.required("Saldo Deduzido Obrigatório")
			.maxLength(200, "Deve ser menor ou igual a 200")
		},
		"obras.enderecoObra": function(value){
			return Validator.value(value)
			.required("Endereço Obra Obrigatório")
			.maxLength(200, "Deve ser menor ou igual a 200")
		},
		"obras.nome": function(value){
			return Validator.value(value)
			.required("Nome Obra Obrigatório")
			.maxLength(200, "Deve ser menor ou igual a 200")
		},
		"selectedTipoObra": function(value){
			return Validator.value(value)
			.required("Tipo Obra Obrigatório")
			.maxLength(200, "Deve ser menor ou igual a 200")
		},
		"selectedTipoDesconto": function(value){
			return Validator.value(value)
			.required("Tipo Desconto Obrigatório")
			.maxLength(200, "Deve ser menor ou igual a 200")
		},
		"obras.descricao": function(value){
			return Validator.value(value)
			.required("Descrição Obra Obrigatório")
			.maxLength(200, "Deve ser menor ou igual a 200")
		}
	},
}
</script>

<style scoped>
.p-inputtext:disabled {
  color: #a6a6a6;
  border-color: #a6a6a6;
}
textarea {
  width: 100%;
  border-radius: 12px;
}
</style>